import styled from 'styled-components'

import { Box, Flex } from 'app/components/design-system-components'
import { TelField } from 'app/components/design-system-components/inputs'
import { fontWeightsWithAliases } from 'app/components/design-system-components/styles/variables'
import { FieldWrapper } from 'app/forms/FieldWrapper'
import theme from 'app/match/applicationReportPDF/assets/theme'

export const StyledFlexBox = styled(Flex)`
  > *:first-child {
    margin-right: 8px;
  }

  > *:not(:first-child) {
    margin-left: 8px;
  }
`

export const StyledInputWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: ${theme.space[7]}px;
  @media screen and (max-width: 576px) {
    display: block;
    margin-top: ${theme.space[0]}px;
  }
`

export const StyledFieldWrapper = styled(FieldWrapper)`
  width: ${theme.width[10]}px;
  @media screen and (max-width: 576px) {
    width: 100%;
    margin-top: ${theme.space[3]}px;
  }
  label {
    border-color: ${theme.colors.gray500};
  }
  label:first-child {
    > div {
      margin-bottom: ${theme.space[5]}px;
    }
  }
  label[disabled] {
    background-color: ${theme.colors.gray200};
  }
  input {
    height: ${theme.dividedSpace[6]}px;
  }
  input[disabled] {
    color: ${theme.colors.gray500};
    background-color: ${theme.colors.gray200};
    font-weight: ${fontWeightsWithAliases.h6};
  }
  button {
    border-color: ${theme.colors.gray500};
    height: 48px;
  }
  .date-time {
    input {
      height: 48px;
    }
  }
`

export const StyledSubText = styled.p`
  font-size: ${theme.fontSizes.pSmall12};
  color: ${theme.colors.gray600};
`

export const CustomMobileInput = (props: any) => (
  <TelField onlyCountries={[]} {...props} />
)
